module.exports = __webpack_public_path__ + "static/media/moment02.008cc031.webp";